// values are synced with rrule lib in nodejs

export default [
  { label: "Don't repeat", value: null },
  { label: 'Daily', value: '3', name: 'Day' },
  { label: 'Weekly', value: '2', name: 'Week' },
  { label: 'Monthly', value: '1', name: 'Month' },
  { label: 'Yearly', value: '0', name: 'Year' }
];
